import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { TabStripModule } from '@progress/kendo-angular-layout';
@Component({
  selector: 'app-parameter-tabs',
  templateUrl: './parameter-tabs.component.html',
  // styleUrls: ['./parameter-tabs.component.scss']
})
export class ParameterTabsComponent implements OnInit {

  constructor()

  { }



  ngOnInit() {


  }
}
